import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { LoadingContext, M_Table, NavigateContext } from 'src/M_Components'

export const UsersGroupsList = ({ roles, tablesOrder = [], onTablesOrderUpdate }) => {
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)

    const newRoute = (url, operation, label, row) => {
        if (operation === 'Edit') {
            if (row) {
                ctx.setPassValues({ Operation: operation, Row: row })
            } else {
                return
            }
        }
        if (operation === 'Create') ctx.setPassValues({ Operation: operation })
        ctx2.newTab(url, label)
    }

    return (
        <M_Table
            entityName={'UsersGroup'}
            roleName={'usersGroups'}
            rolePermissions={roles}
            tablesOrder={tablesOrder}
            onTablesOrderUpdate={onTablesOrderUpdate}
            pageUrl={'User Groups'}
            removeContextItems={['Print', 'Copy']}
            replaceFunctions={new Map([
                ['Create', (row) => newRoute('go/usersGroupsCrud', 'Create', t('CreateUsersGroup'), row)],
                ['Edit', (row) => newRoute('go/usersGroupsCrud', 'Edit', t('EditUsersGroup'), row)]
            ])}
        />
    )
}
